module.exports = __webpack_public_path__ + "static/media/pimiento-color.ab676635.svg";